import { useTranslation } from "react-i18next";

import {
  HookFormInput,
  HookFormTextArea,
  HookFormBaseDropdown,
} from "@/components_v2/FormFields/ReactHookForm/fields";
import FormFieldWrapper from "@/components_v2/Wrapper/FormFieldWrapper";
import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_VARIANTS } from "@/components_v2/Button/constants";
import { PersonalDetailsStepProps } from "../types";

const PersonalDetailsStep = ({
  form,
  organizations,
  isSubmitting,
  handleBack,
  handleSubmit,
}: PersonalDetailsStepProps) => {
  const { t } = useTranslation();

  const organizationOptions = organizations.map((organization) => ({
    value: organization.id,
    label: organization.name,
  }));

  return (
    <div className="flex flex-col gap-400">
      <div className="flex flex-col gap-200">
        <h2 className="apply-to-join__title header-m-medium">
          {t("applications.labels.createAccountTitle")}
        </h2>
        <p className="apply-to-join__description body-m-regular">
          {t("applications.labels.personalDetailsDescription")}
        </p>
      </div>

      <div className="form-input-container text-start">
        <div className="flex gap-200">
          <FormFieldWrapper label={t("applications.labels.firstName")} required>
            <HookFormInput
              name="firstName"
              placeholder={t("applications.placeholders.enterFirstName")}
              control={form.control}
            />
          </FormFieldWrapper>

          <FormFieldWrapper label={t("applications.labels.lastName")} required>
            <HookFormInput
              name="lastName"
              placeholder={t("applications.placeholders.enterLastName")}
              control={form.control}
            />
          </FormFieldWrapper>
        </div>

        <FormFieldWrapper
          label={t("applications.labels.organization")}
          required
        >
          <HookFormBaseDropdown
            name="organization"
            placeholder={
              organizations.length > 1
                ? t("applications.placeholders.selectOrganization")
                : undefined
            }
            options={organizationOptions}
            control={form.control}
            disabled={organizations.length <= 1}
          />
        </FormFieldWrapper>

        <FormFieldWrapper label={t("applications.labels.message")}>
          <HookFormTextArea
            name="note"
            placeholder={t("applications.placeholders.enterMessageToAdmin")}
            control={form.control}
          />
        </FormFieldWrapper>
      </div>

      <div className="flex gap-300 full-width">
        <BaseButton
          variant={BUTTON_VARIANTS.TERTIARY}
          className="flex-1"
          onClick={handleBack}
        >
          {t("applications.labels.back")}
        </BaseButton>
        <BaseButton
          className="flex-1"
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          {t("applications.labels.submitApplication")}
        </BaseButton>
      </div>
    </div>
  );
};

export default PersonalDetailsStep;
